import Vue from 'vue';
import { common } from '@tencent/ceiba-base-components';

let loginManagerInstance = null;

function loginByQQ(loginManager) {
  loginManager.mobileLoginByQQConnect({
    appId: '101478665',
    redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
    sUrl: location.href,
  });

  localStorage.curPlatform = 'qq';
}

function loginByWx(loginManager) {
  loginManager.mobileLoginByWX({
    appId: 'wx5a3bbeac0d87c75a',
    scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
    userinfoSpan: 'userinfo',
    forcePopup: true,
    snapShotTips: true,
    snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的查询、抽奖、领取、发货、签到等操作”',
  });

  localStorage.curPlatform = 'wx';
}

export default class LoginBase {
  async initLogin() {
    // 因为midas只支持qc登录态,所以心悦先强制qc.
    window.iUseQQConnect = 1;
    console.log('LoginBase initLogin begin');
    return await new Promise((resolve) => {
      loginManagerInstance = new Vue.prototype.$miloLoginManager({
        commonParams: {
          iUseQQConnect: window.iUseQQConnect,
        },
        mobileParams: {
          oWXParams: {
            gameDomain: 'xinyue.qq.com',
            appId: 'wx5a3bbeac0d87c75a',
            scope: 'snsapi_userinfo',
          },
          oQQConnectParams: {
            appId: '101478665',
            redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
            sUrl: location.href,
          },
        },
      });
      console.log('tgclub initLogin done instance=', loginManagerInstance);
      resolve();
    });
  }

  async login(params = { loginType: 'qq' }) {
    console.log('LoginBase login|params=', params);
    if (params.loginType === 'qq') loginByQQ(loginManagerInstance);
    if (params.loginType === 'wx') loginByWx(loginManagerInstance);
  }

  async checkLogin(params) {
    console.log('LoginBase checkLogin|params=', params);
    const cookieAcctype = common.tool.getCookie('acctype');
    if (!Boolean(cookieAcctype) || cookieAcctype === 'pt') {
      // cookie中没有acctype,异或acctype为pt则非法,直接返回未登录
      return {
        isLogin: false,
        userInfo: {},
      };
    }
    return await new Promise((resolve) => {
      console.log('loginManagerInstance', loginManagerInstance);
      loginManagerInstance.checkLogin().then((res) => {
        const { isLogin, userInfo } = res;
        console.log('checkLogin', userInfo);
        // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
        //
        let { curPlatform } = localStorage;
        console.log('checkLogin curPlatform from localStorage ', curPlatform);

        if (!curPlatform) {
          curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
        }
        console.log('checkLogin curPlatform ', curPlatform);
        resolve({
          isLogin,
          userInfo,
        });
      })
        .catch((err) => {
          common.tool.clearAllCookie();
          console.error('checkLogin Failed:', err);
          console.error('checkLogin Failed Code:', err.errCode);
          console.error('checkLogin Failed info:', err.errInfo);
          const { isQQ, isWX } = Vue.prototype.$platform;
          console.log('.isWX = ', isWX);
          console.log('.isQQ = ', isQQ);
          const { game_type: gameType = 0 } = Vue.prototype.$actInfo || {};
          //  微信在端游的时候不拉去分享
          // eslint-disable-next-line camelcase
          console.log('game_type from state= ', gameType);
          console.log('Vue.prototype.$actInfo ', Vue.prototype.$actInfo);
          // 默认端游不进行微信登录
          isQQ && loginByQQ(loginManagerInstance);
          // eslint-disable-next-line camelcase
          isWX && gameType !== 1 && loginByWx(loginManagerInstance);
          console.log('game_type =', gameType, 'game_type === 1 是端游 默认端游不进行微信登录');
          resolve({
            isLogin: false,
            userInfo: {},
          });
        });
    });
  }

  async logout() {
    await loginManagerInstance.logout({});
    localStorage.curPlatform = '';
    common.tool.clearAllCookie();
  }

  async checkRoleInfo(params) {
    console.log('LoginApp checkRoleInfo|param=', params);
    return {
      defaultPlugin: true,
      isRoleReady: false,
      roleInfo: {},
    };
  }
}
